import React, { useEffect, useContext } from "react";
import { Field } from "react-final-form";
import "../../General/FinalFormModal/FinalFormModal.css";
import { QuestionContext } from "../../../Utils/contexts/QuestionContext";
import { ModalInput } from "../../General/ModalInput/ModalInput";
import "./FinalFormQuestionModal.css"; 

const AnswerOptionInputFields = () => {
  const { selectedQuestion,  language} = useContext(
    QuestionContext
  );
  const answerOptionInput = (index, formulation, language) => {
    let header = "";

    switch(language){
      case "EN":
        header = `Answer option ${index + 1}`;
        break;
      default:
        header = `Svarsalternativ ${index + 1}`;
    } 
    return {
      header,
      id: header,
      divName: "AnswerOptionInput",
      type: "text",
      labelName: "Text-left",
      placeHolder: formulation,
      style: {display: "flex", flexDirection: "column", width: "98%"},
    };
  };
  
  useEffect(() => {
  }, [language, selectedQuestion]);
  
  
  return (
    <>
      <div>
        {language.includes("SE") &&
        ["", "", "", "", ""].map((answer, index) => {      
          
          const inputField = answerOptionInput(index, "", language);
          return (
            <div className="Input-column" key={`sweFormAnswerOption${index}`}>   
              <Field  name={inputField.header} key={`sweFormAnswerOption${index}`}>
                {({ input, meta }) => (
                  <ModalInput 
                    labelName="input-label" 
                    input={input} 
                    inputField={inputField} 
                    meta={meta}/>
                )}
              </Field>
            </div>
          );
        })}
      </div>
      <div> 
        {language.includes("EN") && 
        ["", "", "", "", ""].map((answer, index) => {
          const inputField = answerOptionInput(index, "", language);
          return (
            <div className="Input-column" key={`enFormAnswerOption${index}`}>   
              <Field name={inputField.header} key={`enFormAnswerOption${index}`}>
                {({ input, meta }) => (
                  <ModalInput 
                    labelName="input-label" 
                    input={input} 
                    inputField={inputField} 
                    meta={meta}/>
                )}
              </Field>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AnswerOptionInputFields;